import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { clearSession, getSession } from "@/lib/api";
import { TopBar } from "@/components/fly/Logo";
import { RegistrationBoard } from "@/components/fly/RegistrationBoard";

export default function Registration() {
  const nav = useNavigate();
  const s = getSession();
  return (
    <>
      <TopBar title={s?.name} right={
        <button data-testid="reg-logout-btn" onClick={() => { clearSession(); nav("/rejestracja/login"); }} className="h-10 px-3 rounded-lg border border-white/10 text-slate-300 hover:text-white hover:bg-white/5 flex items-center gap-2 text-sm">
          <LogOut className="w-4 h-4" /><span className="hidden sm:inline">Wyloguj</span>
        </button>
      } />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <div className="no-print">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400">{s?.name}</p>
          <h1 className="font-display text-4xl font-extrabold uppercase">Rejestracja zawodników</h1>
        </div>
        <RegistrationBoard />
      </main>
    </>
  );
}
